var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApprove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4427 18H4.3759V6.48L10.679 0L11.5632 0.6975C11.6539 0.7725 11.722 0.8775 11.7673 1.0125C11.8126 1.1475 11.8353 1.3125 11.8353 1.5075V1.7325L10.815 6.48H17.5943C17.957 6.48 18.2745 6.615 18.5465 6.885C18.8186 7.155 18.9547 7.47 18.9547 7.83V9.675C18.9547 9.78 18.966 9.88875 18.9887 10.0013C19.0113 10.1137 19 10.2225 18.9547 10.3275L16.0979 16.8525C15.9618 17.1675 15.7389 17.4375 15.429 17.6625C15.1191 17.8875 14.7904 18 14.4427 18ZM5.73628 16.65H14.7375L17.5943 9.9225V7.83H9.13723L10.3389 2.2275L5.73628 7.0425V16.65ZM5.73628 7.0425V16.65V7.0425ZM4.3759 6.48V7.83H1.36038V16.65H4.3759V18H0V6.48H4.3759Z",
    fill: "#00BD9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprove);
export default __webpack_public_path__ + "static/media/Approve.fd04b36883eb5a279b8b14a9883a41f2.svg";
export { ForwardRef as ReactComponent };